import { Helmet } from "react-helmet-async";

const SITE = "https://jclawsc.org";
const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/b33e0569-2265-436b-8247-a65606b6cf84/images/8936575d4e94b80247c2e4692a0c84ff36f6fe8d010ab58fcfa0e8e1e796f834.png";

export const Seo = ({ title, description, path = "/", image = DEFAULT_OG, type = "website", schema }) => {
    const fullTitle = title
        ? `${title} | JC Law Foundation`
        : "JC Law Foundation | Hotel Cardiac Emergency Preparedness Act — Every Second Matters";
    const desc = description || "The JC Law Foundation advocates for CPR-trained hotel staff and accessible AEDs. Sign the petition. Share JC's story. Help save lives.";
    const url = `${SITE}${path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:type" content={type} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={image} />
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </Helmet>
    );
};

export default Seo;
